import { HTMLAttributes } from 'react'

export interface LoadingSpinnerProps extends HTMLAttributes<HTMLDivElement> {
  size?: 'sm' | 'md' | 'lg'
}

export const LoadingSpinner = ({
  size = 'md',
  className = '',
  ...props
}: LoadingSpinnerProps) => {
  const sizeClasses = {
    sm: 'w-4 h-4 border-2',
    md: 'w-6 h-6 border-2',
    lg: 'w-8 h-8 border-3',
  }

  return (
    <div
      className={`${sizeClasses[size]} border-text-muted border-t-primary rounded-full animate-spin ${className}`}
      {...props}
      aria-label="Loading"
      role="status"
    />
  )
}
